import type { ExplorerFinding } from '../../../../models/explorer/ExplorerFinding';
import type { FindingRule, FindingRuleContext } from '../types';
import { boolProp, isOneOfService, propsOf } from './_graphHelpers';

const DATA_SERVICES = [
  'rds',
  'db-instance',
  'db-cluster',
  'aurora',
  's3',
  'bucket',
  'ebs',
  'volume',
  'dynamodb',
  'table',
  'redshift',
] as const;

/**
 * P0.3 — unencrypted data at rest.
 * Severity: critical. Maps to SOC 2 CC6.1 / ISO 27001 A.10.
 */
export const unencryptedDataStoreRule: FindingRule = {
  id: 'unencrypted_data_store',
  label: 'Unencrypted data store',
  description: 'Data store with encryption at rest disabled.',

  run(ctx: FindingRuleContext): readonly ExplorerFinding[] {
    const findings: ExplorerFinding[] = [];
    for (const node of ctx.graph.nodes) {
      if (!isOneOfService(node, DATA_SERVICES)) continue;
      const p = propsOf(node);
      const atRest = boolProp(p, ['encryption', 'atRest']);
      // Undefined → unknown; don't fire. Only fire when explicitly false.
      if (atRest === false) {
        findings.push({
          id: `unencrypted_data_store:resource:${node.id}`,
          ruleId: 'unencrypted_data_store',
          severity: 'critical',
          scope: 'resource',
          subject: { kind: 'resource', id: node.id },
          title: 'Unencrypted data at rest',
          detail: `${String(node.label ?? node.id)} stores data without encryption at rest.`,
        });
      }
    }
    return findings;
  },
};
